export default __webpack_public_path__ + "static/media/baby-37.ecbda0dd.svg";